function waitElementLoaded(a, b, c = 100) {
    const d = setInterval(function () {
      const c = document.querySelector(a);
      c && (b(), clearInterval(d));
    }, c);
    setTimeout(function () {
      clearInterval(d);
    }, 5e3);
  }
  function waitForCustomerReferralLoaded(a, b = 100) {
    const c = setInterval(function () {
      "undefined" != typeof scaAffCustomerRefer && (a(), clearInterval(c));
    }, b);
    setTimeout(function () {
      clearInterval(c);
    }, 5e3);
  }
  
  let processedSpan = false;
  const referAndEarnTextSelector = `.sca_aff_customer_refer_button span`;
  waitForCustomerReferralLoaded(waitElementLoaded(referAndEarnTextSelector, function () {
    if (processedSpan) return;
    
    const element = document.querySelector(referAndEarnTextSelector);
    const oldText = element.textContent;
    const newNode = document.createElement('h2');
    newNode.textContent = oldText;
    element.parentElement.insertBefore(newNode, element);
    console.log(element, "Processed");
    element.remove();
    processed = processedSpan;
  }));
  
  let proccessHeader = false;
  const referAndHeaderSelector = `.sca_aff_customer_refer_invite_header`;
  waitForCustomerReferralLoaded(waitElementLoaded(referAndHeaderSelector, function () {
    if (proccessHeader) return;
    const buttonText = document.querySelector('.sca_aff_customer_refer_button h2')
    if (buttonText) {
      const newButtonText = document.createElement('span')
      newButtonText.textContent = buttonText.textContent
      buttonText.after(newButtonText)
      buttonText.remove()
    }
    const element = document.querySelector(referAndHeaderSelector);
    const oldText = element.textContent;
    const newNode = document.createElement('h2');
    [...element.classList].forEach(className => newNode.classList.add(className));
    newNode.textContent = oldText;
    element.parentElement.insertBefore(newNode, element);
    element.remove();
    proccessHeader = true;
  }));